import { PairingUpsertScreen } from '../features/pairings/screens/PairingUpsertScreen';

export const PairingCreatePage = () => {
  return <PairingUpsertScreen mode="create" />;
};
